import AuthService from '../../service';
const sponserProgram = {
  getSponserProgram(page,search,sort_order){
    return AuthService.get(`/about/sponser_program?page=${page}&search=${search}&sort_order=${sort_order}`);
  },
  showSponserProgram(id){
    return AuthService.get(`/about/sponser_program/${id}`);
  },
  createSponserProgram(data){
    return AuthService.post(`/about/sponser_program`,data);
  },
  updateSponserProgram(id,data){
    return AuthService.put(`/about/sponser_program/${id}`,data);
  },
  deleteSponserProgram(id){
    return AuthService.delete(`/about/sponser_program/${id}`);
  },
}
export default sponserProgram
